import { statsData } from "@/mocks/homeData";

export default function StatsBar() {
  return (
    <section className="bg-foreground-950">
      <div className="grid grid-cols-2 lg:grid-cols-4">
        {statsData.map((item, index) => (
          <div
            key={item.label}
            className={`flex items-center gap-3 px-5 md:px-8 py-6 md:py-7 ${
              index !== 0 ? "lg:border-l lg:border-background-50/10" : ""
            } ${index % 2 === 1 ? "border-l border-background-50/10 lg:border-l" : ""} ${
              index >= 2 ? "border-t border-background-50/10 lg:border-t-0" : ""
            }`}
          >
            <span className="w-10 h-10 shrink-0 rounded-md bg-primary-500/20 flex items-center justify-center text-accent-400">
              <i className={`${item.icon} text-lg`}></i>
            </span>
            <div className="min-w-0">
              <p className="font-heading text-xl md:text-2xl font-bold text-background-50 leading-none">
                {item.value}
              </p>
              <p className="mt-1.5 text-xs md:text-sm text-background-300 whitespace-nowrap">
                {item.label}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}